import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppNotification, AppNotificationType } from '@app/models';
import { NotificationService } from '@app/services';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  public notifications$: Observable<AppNotification[]>;
  public unreadCount$: Observable<number>;

  public isDropdownOpen = false;

  private subscriptions: Subscription[] = [];

  constructor(public notificationService: NotificationService) {}

  ngOnInit(): void {
    this.notifications$ = this.notificationService.notifications$;
    this.unreadCount$ = this.notificationService.unreadCount$;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public onNotificationClick(notification: AppNotification): void {
    this.notificationService.navigateToNotification(notification);
  }

  public clearAll(): void {
    this.notificationService.clearAll();
  }

  public removeNotification(event: Event, notificationId: string | number): void {
    event.stopPropagation();
    this.notificationService.removeNotification(notificationId);
  }

  public getIcon(type: AppNotificationType): string {
    return this.notificationService.getIconForType(type);
  }

  public getColorClass(type: AppNotificationType): string {
    return this.notificationService.getColorClassForType(type);
  }

  public getTimeAgo(date: Date): string {
    const now = new Date();
    const diffMs = now.getTime() - new Date(date).getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) {
      return 'Agora';
    } else if (diffMins < 60) {
      return `${diffMins} min`;
    } else if (diffHours < 24) {
      return `${diffHours}h`;
    } else if (diffDays < 7) {
      return `${diffDays}d`;
    } else {
      return new Date(date).toLocaleDateString('pt-BR');
    }
  }

  public onDropdownChange(isOpen: boolean): void {
    this.isDropdownOpen = isOpen;

    // Ao abrir o dropdown, marca todas como lidas
    if (isOpen) {
      this.notificationService.markAllAsRead();
    }
  }

  public trackByNotificationId(
    index: number,
    notification: AppNotification
  ): string | number {
    return notification.id;
  }
}
